// extracted by mini-css-extract-plugin
module.exports = {"heading":"Heading_heading__27mM_","xs":"Heading_xs__66N-S","sm":"Heading_sm__1IoUr","md":"Heading_md__1hRBf","lg":"Heading_lg__19ie0","xl":"Heading_xl__1reZ8"};